import { getRequest } from "lib/core/apiClient";
import { getAuthCookies } from "lib/utils/auth";

/**
 * Single `/authenticate/me` URL for SWR keys, `getRequest`, and `mutate` (must stay identical).
 */
export const AUTHENTICATE_ME_QUERY =
  "required_identifiers=true&populate_external_data=true&populate_account_attributes=true&populate_email_from_account_attributes=true";

export const AUTHENTICATE_ME_PATH = `/authenticate/me?${AUTHENTICATE_ME_QUERY}`;

/**
 * Shared SWR fetcher for `/authenticate/me` (same key everywhere → one network request, shared cache).
 */
export const fetchAuthenticateMe = async (url: string) => {
  const cookies = getAuthCookies();
  if (!cookies) {
    return null;
  }
  return getRequest(url, "AUTH_PRIVATE");
};

/**
 * `getRequest(..., "AUTH_PRIVATE")` returns `response.data.data` (inner account object).
 * Some callers may still pass a full envelope — normalize to the account payload.
 */
export type AuthIdentifier = {
  oid?: string;
  oid_type?: string;
  verified?: boolean;
};

export type AuthenticateMeAccountPayload = {
  id?: string;
  email?: string | null;
  auth_identifiers?: AuthIdentifier[];
  customer_config?: {
    email?: string | null;
  };
};

export const parseAuthenticateMeAccount = (raw: unknown): AuthenticateMeAccountPayload => {
  if (!raw || typeof raw !== "object") {
    return {};
  }
  const record = raw as Record<string, unknown>;
  const nested = record.data;
  if (nested && typeof nested === "object") {
    return nested as AuthenticateMeAccountPayload;
  }
  return raw as AuthenticateMeAccountPayload;
};
